import { render, staticRenderFns } from "./tenant-creation.vue?vue&type=template&id=2c674cba&scoped=true&"
import script from "./tenant-creation.ts?vue&type=script&lang=ts&"
export * from "./tenant-creation.ts?vue&type=script&lang=ts&"
import style0 from "./tenant-creation.scss?vue&type=style&index=0&id=2c674cba&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c674cba",
  null
  
)

export default component.exports